import React from 'react'

import { Typography, Button, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 48,
		textAlign: 'center'
	},
	title: {
		marginBottom: 8
	},
	message: {
		color: '#777679',
		marginBottom: 24
	}
}))

const Fallback = ({ onReset }) => {
	const classes = useStyles()

	return (
		<div className={classes.container}>
			<Typography variant="h6" className={classes.title}>
				Something went wrong.
			</Typography>
			<Typography variant="body2" className={classes.message}>
				Try reloading it. If the failure continues, please let us know.
			</Typography>
			<Button variant="outlined" onClick={onReset}>
				Reload
			</Button>
		</div>
	)
}

// Catches render/commit-time errors in the subtree so a transient
// reconciliation failure degrades to a recoverable fallback instead of
// white-screening the whole admin.
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false }
		this.handleReset = this.handleReset.bind(this)
	}

	static getDerivedStateFromError() {
		return { hasError: true }
	}

	componentDidCatch(error, info) {
		// eslint-disable-next-line no-console
		console.error('ErrorBoundary caught an error', error, info)
	}

	handleReset() {
		this.setState({ hasError: false })
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback
			return <Fallback onReset={this.handleReset} />
		}

		return this.props.children
	}
}

export default ErrorBoundary
